import { ROTA_CENTRAL_ATENDIMENTOS } from '../constants/catalogoMomentos';

/**
 * A rota comporta o cartão de pesquisa?
 *
 * Existe como função pura, e não como `pathname.startsWith(...)` inline no shell,
 * por dois motivos. O primeiro é que ela é o conserto de um bug real — o cartão
 * montado na Central de Atendimentos consumia a pesquisa sem aparecer para ninguém
 * (review do PR #955, COR-01) — e regra de conserto precisa de teste que a exercite;
 * montar o `LayoutWrapper` inteiro num teste custaria caro por muito menos.
 *
 * O segundo é o casamento: prefixo cru diria que `/chatbot` é a Central de
 * Atendimentos. A comparação é por SEGMENTO — a rota exata ou algo abaixo dela.
 *
 * @example deveMontarPesquisaNaRota('/chat/123') // false
 * @example deveMontarPesquisaNaRota('/chatbot')  // true
 */
export function deveMontarPesquisaNaRota(pathname: string | null): boolean {
  if (!pathname) return false;
  return !(
    pathname === ROTA_CENTRAL_ATENDIMENTOS || pathname.startsWith(`${ROTA_CENTRAL_ATENDIMENTOS}/`)
  );
}
